import React, { useEffect, useState } from 'react';
import { addDays, formatDate } from "../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from "sweetalert2";
import CircularLoader from "../../Component/CircularLoader";
import { IoMdLock } from "react-icons/io";

const AkberKare = () => {
    const [loading, setLoading] = useState(false);
    const [currentDate] = useState(new Date());
    const newDate = addDays(currentDate, 3);
    const [step, setStep] = useState(1);
    const [donationType, setDonationType] = useState('once');
    const [currency, setCurrency] = useState('PKR');
    const [donationPurpose, setDonationPurpose] = useState('General'); // Default donation purpose
    const [showCustomAmount, setShowCustomAmount] = useState(false);
    const [credentials, setCredentials] = useState({
        username: "",
        password: "",
        clientId: "",
        clientSecret: ""
    });
    const [userInfo, setUserInfo] = useState({
        firstName: '',
        lastName: '',
        email: '',
        contactNumber: '',
        address: '',
        country: 'Pakistan',
        province: '',
        zipCode: '',
        city: '',
        amount: '',
        currency: "PKR",
        donationPurpose: "General",
        educationType: "Early Intervention" // Add educationType to userInfo
    });

    const nextStep = () => {
        if (validateStep1()) {
            setStep(step + 1);
        }
    };

    const prevStep = () => setStep(step - 1);

    const validateStep1 = () => {
        // if (!donationAmount) {
        //     Swal.fire({
        //         icon: "error",
        //         title: "Please select or enter a donation amount.",
        //         showConfirmButton: false,
        //         timer: 1500
        //     });
        //     return false;
        // }
        if (!donationPurpose) {
            Swal.fire({
                icon: "error",
                title: "Please select a donation purpose.",
                showConfirmButton: false,
                timer: 1500
            });
            return false;
        }
        return true;
    };

    const validateStep2 = () => {
        const requiredFields = ['firstName', 'lastName', 'email',];
        for (const field of requiredFields) {
            if (!userInfo[field]) {
                Swal.fire({
                    icon: "error",
                    title: `Please fill out the ${field.replace(/([A-Z])/g, ' $1').toLowerCase()} field.`,
                    showConfirmButton: false,
                    timer: 1500
                });
                return false;
            }
        }
        return true;
    };



    const handleUserInfoChange = (e) => {
        const { name, value } = e.target;
        setUserInfo({ ...userInfo, [name]: value });
    };

    let payload;
    if (userInfo.currency === "PKR") {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: userInfo?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: userInfo?.firstName + " " + userInfo?.lastName,
                CustomerMobile: userInfo?.contactNumber ?? "",
                CustomerEmail: userInfo?.email,
                CustomerAddress: userInfo?.address ?? '',
                BillDetail01: [
                    {
                        internationalNumber: userInfo?.currency === "USD" || userInfo?.currency === "AED" ? userInfo?.contactNumber : "",
                        purposeOfDonation: userInfo?.donationPurpose,
                        zipCode: userInfo.zipCode,
                        educationType: userInfo.educationType // Use educationType from userInfo
                    }
                ]
            }
        ];
    } else {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: userInfo?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: userInfo?.firstName + " " + userInfo?.lastName,
                CustomerMobile: userInfo?.currency === "PKR" ? userInfo?.contactNumber : "",
                CustomerEmail: userInfo?.email,
                CustomerAddress: userInfo?.address ?? '',
                Currency: userInfo?.currency,
                IsConverted: "true",
                BillDetail01: [
                    {
                        internationalNumber:  userInfo?.currency === "PKR" ? "" : userInfo?.contactNumber,
                        purposeOfDonation: userInfo?.donationPurpose,
                        zipCode: userInfo.zipCode,
                        educationType: userInfo.educationType // Use educationType from userInfo
                    }
                ]
            }
        ];
    }

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();

        if (!validateStep2()) {
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if (response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            } else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Payment",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                window.top.location.href = marketplaceUrl;
            }

        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }



    useEffect(() => {
        setCredentials(prev => ({
            ...prev, // Keep other values if needed
            username: userInfo.donationPurpose === "Zakat" ? "AkbarKare_Zakat" : "AkbarKare_Donat",
            password: userInfo.donationPurpose === "Zakat" ? "Live@az25" : "Live@ad25",
            clientId: userInfo.donationPurpose === "Zakat" ? "sDxGjWf1yDiwS2D" : "fT0jCiuTEF6UIkL",
            clientSecret: userInfo.donationPurpose === "Zakat" ? "1WNcjOvBwxlOqXe" : "nxQKvxdNFjZy3Bz"
        }));
    }, [userInfo.donationType]);

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
            <div className="flex items-center mb-4  gap-1">
                <h2 className="text-xl font-semibold ">Secure Donation</h2>
                <IoMdLock size={18} />
            </div>
            <form onSubmit={payproCreateOrder}>
                {step === 1 && (
                    <div>
                        {/*<div className="mb-4">*/}
                        {/*    <select*/}
                        {/*        className="block w-full px-4 py-2 rounded border text-center border-gray-300"*/}
                        {/*        name="educationType" // Add name attribute*/}
                        {/*        value={userInfo.educationType}*/}
                        {/*        onChange={handleUserInfoChange}*/}
                        {/*    >*/}
                        {/*        <option value="Early Intervention">Early Intervention</option>*/}
                        {/*        <option value="Physical Therapy">Physical Therapy</option>*/}
                        {/*        <option value="Assistive Device">Assistive Device</option>*/}
                        {/*        <option value="Early Education">Early Education</option>*/}
                        {/*        <option value="Sponsor a child">Sponsor a child</option>*/}
                        {/*    </select>*/}
                        {/*</div>*/}

                        <label className="block text-gray-700 text-sm font-bold mb-2">Donation Type</label>
                        <div className="flex space-x-4 mb-4">
                            <button
                                type="button"
                                onClick={() => {
                                    setDonationType('once')
                                }}
                                className={`px-4 py-2 rounded ${donationType === 'once' ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                            >
                                Give Once
                            </button>
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">Currency</label>
                            <div className="flex space-x-4 mb-4">
                                {['PKR', "USD", 'AED'].map((curr) => (
                                    <button
                                        key={curr}
                                        type="button"
                                        onClick={() => {
                                            setCurrency(curr);
                                            setUserInfo(prev => ({ ...prev, currency: curr }));
                                        }}
                                        className={`px-4 py-2 rounded ${currency === curr ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                    >
                                        {curr}
                                    </button>
                                ))}
                            </div>

                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">Amount</label>
                                <div className="grid grid-cols-3 gap-2 mb-4">
                                    {["100", "1000", "2000"]?.map((amount) => (
                                        <button
                                            key={amount}
                                            type="button"
                                            onClick={() => {
                                                // setDonationAmount(amount);
                                                setShowCustomAmount(false);
                                                setUserInfo(prev => ({ ...prev, amount: amount }));
                                            }}
                                            className={`px-4 py-2 rounded ${userInfo?.amount === amount && !showCustomAmount ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                        >
                                            {currency} {amount}
                                        </button>
                                    ))}
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowCustomAmount(!showCustomAmount);
                                            setUserInfo(prev => ({ ...prev, amount: '' }));
                                        }}
                                        className={`px-4 py-2 rounded ${showCustomAmount ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                    >
                                        Other
                                    </button>
                                </div>
                                {showCustomAmount && (
                                    <div className='flex items-center  gap-1  rounded border border-gray-300 '>
                                        <span className="text-xl font-bold p-2 border-r-2 ">{currency}</span>
                                        <input
                                            type="number"
                                            placeholder="Enter custom amount"
                                            name="amount" // Add name attribute
                                            value={userInfo.amount || ''}
                                            onChange={handleUserInfoChange} // Use handleUserInfoChange
                                            className="w-full p-2 appearance-none focus:outline-none focus:ring-0 [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                        />
                                    </div>

                                )}

                                <label className="block text-gray-700 text-sm font-bold mb-2 pt-2">Donation Purpose</label>
                                <div className="flex space-x-4 mb-4">
                                    {['General', 'Zakat', 'Sadqah'].map((curr) => (
                                        <button
                                            key={curr}
                                            type="button"
                                            onClick={() => {
                                                setDonationPurpose(curr);
                                                setUserInfo(prev => ({ ...prev, donationPurpose: curr }));
                                            }}
                                            className={`px-4 py-2 rounded ${donationPurpose === curr ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                        >
                                            {curr}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={nextStep}
                            className="w-full bg-blue-800 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                            Next
                        </button>
                    </div>
                )}

                {step === 2 && (
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Enter Your Information</h3>
                        <div className="space-y-4">
                            <div className="grid grid-cols-2 gap-4">
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name"
                                    value={userInfo.firstName}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                />
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={userInfo.lastName}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                />
                            </div>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={userInfo.email}
                                onChange={handleUserInfoChange}
                                className="w-full px-4 py-2 rounded border border-gray-300"
                            />
                            <input
                                type="text"
                                name="contactNumber"
                                placeholder="Contact Number"
                                value={userInfo.contactNumber}
                                onChange={handleUserInfoChange}
                                className="w-full px-4 py-2 rounded border border-gray-300"
                            />
                            {/*<input*/}
                            {/*    type="text"*/}
                            {/*    name="address"*/}
                            {/*    placeholder="Address"*/}
                            {/*    value={userInfo.address}*/}
                            {/*    onChange={handleUserInfoChange}*/}
                            {/*    className="w-full px-4 py-2 rounded border border-gray-300"*/}
                            {/*/>*/}
                            {/*<div className="grid grid-cols-2 gap-4">*/}
                            {/*    <select*/}
                            {/*        name="country"*/}
                            {/*        value={userInfo.country}*/}
                            {/*        onChange={handleUserInfoChange}*/}
                            {/*        className="px-4 py-2 rounded border border-gray-300"*/}
                            {/*    >*/}
                            {/*        <option value="Pakistan">Pakistan</option>*/}
                            {/*    </select>*/}
                            {/*    <select*/}
                            {/*        name="province"*/}
                            {/*        value={userInfo.province}*/}
                            {/*        onChange={handleUserInfoChange}*/}
                            {/*        className="px-4 py-2 rounded border border-gray-300"*/}
                            {/*    >*/}
                            {/*        <option value="">Select Province</option>*/}
                            {/*        <option value="Sindh">Sindh</option>*/}
                            {/*        <option value="Punjab">Punjab</option>*/}
                            {/*        <option value="Balochistan">Balochistan</option>*/}
                            {/*        <option value="KPK">KPK</option>*/}
                            {/*        <option value="FATA">FATA</option>*/}
                            {/*    </select>*/}
                            {/*</div>*/}
                            {/*<div className="grid grid-cols-2 gap-4">*/}
                            {/*    <input*/}
                            {/*        type="text"*/}
                            {/*        name="zipCode"*/}
                            {/*        placeholder="Zip/Postal Code"*/}
                            {/*        value={userInfo.zipCode}*/}
                            {/*        onChange={handleUserInfoChange}*/}
                            {/*        className="px-4 py-2 rounded border border-gray-300"*/}
                            {/*    />*/}
                            {/*    <input*/}
                            {/*        type="text"*/}
                            {/*        name="city"*/}
                            {/*        placeholder="City"*/}
                            {/*        value={userInfo.city}*/}
                            {/*        onChange={handleUserInfoChange}*/}
                            {/*        className="px-4 py-2 rounded border border-gray-300"*/}
                            {/*    />*/}
                            {/*</div>*/}
                        </div>
                        <div className="flex justify-between mt-5">
                            <button
                                type="button"
                                onClick={prevStep}
                                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                            >
                                Back
                            </button>
                            <button
                                type="submit"
                                className="bg-blue-800 flex items-center gap-1 text-white px-4 py-2 rounded hover:bg-blue-600"
                            >
                                Submit {loading ? <CircularLoader/> : null}
                            </button>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};

export default AkberKare;